import $ from 'jquery';

// https://stackoverflow.com/questions/35358625/jquery-is-not-defined-when-use-es6-import
// used as a side effect to correctly load jquery and expose it to golden layout.
window.jQuery = $;
window.$ = $;
global.jQuery = $;
global.$ = $;
